import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import DailyUpdate from './components/DailyUpdate';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import { categories } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'http://bendionline.com/',
    description: '在韩国漫画网免费阅读韩漫大全，享受下拉式漫画全集在线浏览，资源丰富，更新迅速，分类清晰。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://bendionline.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO schema={homeSchema} />
      <Navbar />

      <main>
        <HeroSection />

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                漫画分类
              </h2>
              <p className="mt-2 text-sm text-foreground-600">按你的喜好探索不同类型的韩漫</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to="/"
                  className="group relative rounded-xl overflow-hidden cursor-pointer h-[200px] md:h-[240px]"
                >
                  <img
                    src={cat.coverImage}
                    alt={cat.name}
                    title={cat.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <h3 className="text-sm md:text-base font-heading font-bold text-white">
                      {cat.name}
                    </h3>
                    <p className="text-[10px] md:text-xs text-white/70 mt-1 line-clamp-1">
                      {cat.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <FeatureGrid />
        <DailyUpdate />
        <Testimonials />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}